export default __webpack_public_path__ + "static/media/profile_unselected.365fa619.svg";